import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { ChevronIcon } from './icon';
import * as style from './styles.css';
export var Chevron = function Chevron(props) {
  var isOpen = props.isOpen,
      onClick = props.onClick;
  return /*#__PURE__*/React.createElement(ChevronIcon, _extends({}, mergeStyles(style['chevron'], isOpen && style['chevron--opened']), {
    onClick: onClick
  }));
};